export const eur = (n) =>
  new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const num = (n) => new Intl.NumberFormat("nl-NL").format(Number(n || 0));

export const dtNL = (iso) => {
  if (!iso) return "-";
  try {
    return new Intl.DateTimeFormat("nl-NL", {
      dateStyle: "short", timeStyle: "short", timeZone: "Europe/Amsterdam",
    }).format(new Date(iso));
  } catch { return iso; }
};

export const dateNL = (iso) => {
  if (!iso) return "-";
  try {
    return new Intl.DateTimeFormat("nl-NL", { dateStyle: "medium", timeZone: "Europe/Amsterdam" }).format(new Date(iso));
  } catch { return iso; }
};

export const RANGES = [
  { key: "today", label: "Vandaag" },
  { key: "this_week", label: "Deze week" },
  { key: "last_30_days", label: "30 dagen" },
  { key: "this_month", label: "Deze maand" },
  { key: "this_year", label: "Dit jaar" },
  { key: "custom", label: "Aangepast" },
];
